module.exports = __webpack_public_path__ + "img/40_01_011_031.75a16667.jpg";